import type { FilterType, SortType } from '../../lib/types';

interface FilterBarProps {
  filter: FilterType;
  sort: SortType;
  search: string;
  onFilterChange: (filter: FilterType) => void;
  onSortChange: (sort: SortType) => void;
  onSearchChange: (search: string) => void;
}

const FILTER_PILLS: { value: FilterType; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'cheaper', label: 'Drops' },
  { value: 'active', label: 'Active' },
  { value: 'award', label: 'Award' },
  { value: 'cash', label: 'Cash' },
];

const SORT_OPTIONS: { value: SortType; label: string }[] = [
  { value: 'date-desc', label: 'Newest First' },
  { value: 'date-asc', label: 'Oldest First' },
  { value: 'savings-desc', label: 'Most Savings' },
  { value: 'price-desc', label: 'Highest Price' },
  { value: 'price-asc', label: 'Lowest Price' },
];

export function FilterBar({
  filter,
  sort,
  search,
  onFilterChange,
  onSortChange,
  onSearchChange,
}: FilterBarProps) {
  return (
    <div className="space-y-3">
      {/* Search */}
      <div className="relative">
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        </svg>
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search by PNR, airline, or route"
          className="w-full pl-10 pr-4 py-2.5 bg-white dark:bg-stone-900 border border-stone-200 dark:border-stone-800 rounded-xl text-sm text-stone-900 dark:text-stone-100 placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-[#FF6B35]/30 dark:focus:ring-[#FF6B35]/20"
        />
      </div>

      {/* Filter pills + sort */}
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-1.5 overflow-x-auto">
          {FILTER_PILLS.map((pill) => (
            <button
              key={pill.value}
              onClick={() => onFilterChange(pill.value)}
              className={`px-3 py-1.5 min-h-[44px] flex items-center text-xs font-medium rounded-full whitespace-nowrap transition-colors ${
                filter === pill.value
                  ? 'bg-stone-900 dark:bg-stone-100 text-white dark:text-stone-900'
                  : 'bg-stone-100 dark:bg-stone-800 text-stone-600 dark:text-stone-400 hover:bg-stone-200 dark:hover:bg-stone-700'
              }`}
            >
              {pill.label}
            </button>
          ))}
        </div>

        <select
          value={sort}
          onChange={(e) => onSortChange(e.target.value as SortType)}
          className="text-xs text-stone-500 dark:text-stone-400 bg-transparent border-none focus:outline-none cursor-pointer"
        >
          {SORT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
